/* eslint-disable react/jsx-no-target-blank */
import styled from "styled-components";
export const Rs = styled.ul`
  position: relative;
  left: 50%;
  bottom: 0;
  margin-bottom: 1rem;
  transform: translate(-50%);
  text-transform: uppercase;
  z-index: 20;
  > li {
    padding: 0.5rem 1rem;
    &:not(:last-child) {
      border-right: 1px solid #fff;
    }
  }
`;

const SocialNetworks = () => {
  return (
    <Rs className="flex justify-center text-center width-full uppercase text-white">
      <li>
        <a href="https://twitter.com/boba_punks" target="_blank">
          Twitter
        </a>
      </li>
      <li>
        <a href="https://t.me/bobapunks" target="_blank">
          Telegram
        </a>
      </li>
    </Rs>
  );
};

export default SocialNetworks;
